/**
 * PlazaHostLockdown — when the visitor is on a Plaza-only host
 * (hustleplaza.au / demo.hustleplaza.au, or the ?as=plaza preview override),
 * this wrapper allows ONLY the plaza routes through. Anything else gets
 * silently redirected to the plaza root so a curious dropshipper can't
 * land on /admin, /menu, /r/<slug>, /pitch/*, etc.
 *
 * Allowed paths on plaza hosts:
 *   /                       → handled by RootRouter (plaza or plaza-demo)
 *   /plaza, /plaza/*
 *   /hustleplaza
 *   /privacy, /terms        (legal pages — keep these reachable)
 */
import { Navigate, useLocation } from "react-router-dom";
import { isPlazaHost } from "@/lib/plazaHost";

const PLAZA_PATH_ALLOWLIST = [
  /^\/$/,
  /^\/plaza(\/|$)/,
  /^\/demo(\/|$)/,
  /^\/admin(\/|$)/,
  /^\/newsletter(\/|$)/,
  /^\/claim(\/|$)/,
  /^\/hustleplaza$/,
  /^\/privacy$/,
  /^\/terms$/,
];

export default function PlazaHostLockdown({ children }) {
  const loc = useLocation();
  if (!isPlazaHost()) return children;
  const ok = PLAZA_PATH_ALLOWLIST.some((rx) => rx.test(loc.pathname));
  if (ok) return children;
  return <Navigate to="/" replace />;
}
